import type {
	Environment as LoomEnvironment,
	SetupArgs as LoomSetupArgs,
} from '@loomhq/record-sdk';

import type { EnvironmentType } from '@atlassian/iap-types';

import type { ProductType } from '../constants';

const PUBLIC_APP_IDS = {
	noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
	staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
	production: {
		development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
		userFacing: '8e345daf-482a-4abf-a612-cb6457110817',
	},
};

type GetLoomInstanceDataByEnvironmentArgs = {
	entryPointName: string;
	environment: EnvironmentType;
	jws: string;
	productName: ProductType;
	siteId: string;
};

export const getLoomInstanceDataByEnvironment = ({
	environment,
	jws,
	siteId,
	productName,
	entryPointName,
}: GetLoomInstanceDataByEnvironmentArgs): LoomSetupArgs => {
	const commonParams = {
		jws,
		siteId,
		config: {
			enableNewUi: true,
			productName,
			entryPointName,
		},
	};

	if (environment === 'dev') {
		return {
			...commonParams,
			mode: 'standard',
			publicAppId: PUBLIC_APP_IDS.noBackend,
			environment: 'production' as LoomEnvironment,
		};
	}

	if (environment === 'staging') {
		return {
			...commonParams,
			mode: 'first-party',
			publicAppId: PUBLIC_APP_IDS.staging,
			environment: 'staging' as LoomEnvironment,
		};
	}

	return {
		...commonParams,
		mode: 'first-party',
		publicAppId:
			process.env.NODE_ENV === 'production'
				? PUBLIC_APP_IDS.production.userFacing
				: PUBLIC_APP_IDS.production.development,
		environment: 'production' as LoomEnvironment,
	};
};
